import * as React from "react";
import { useMemo } from "react";
import { changeLanguage, getCurrentLocale, getLanguages } from "../../locale";
import { useTranslation } from "react-i18next";

export default function LanguageSelector() {
  const currentLocale = getCurrentLocale();
  const { t } = useTranslation();
  const languages = getLanguages();
  const options = useMemo(
    () =>
      languages.map((lng) => ({
        id: lng,
        label: t(`Language:${lng}`),
        active: currentLocale === lng,
      })),
    [languages, t, currentLocale],
  );

  return (
    <select
      className="language-bar"
      onChange={(e) => changeLanguage(e.target.value)}
    >
      {options.map((lang) => (
        <option selected={lang.active} value={lang.id}>
          {lang.label}
        </option>
      ))}
    </select>
  );
}
